import ProfileCard from "components/features/profile/ProfileCard";

export default function Profile() {
  return <ProfileCard />;
}
